import React, { useState, useEffect } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';

import { wsGetAll } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

export default function Write(props) {
  const { bPartner, handleChange } = props;

  const [priceLists, setPriceLists] = useState([]);
  const [countries, setCountries] = useState([]);
  const [banks, setBanks] = useState([]);
  const [taxs, setTaxs] = useState([]);
  const [paymentTerms, setPaymentTerms] = useState([]);

  async function listTaxs() {
    let response = await wsGetAll('base/tax');
    if (response.success) setTaxs(response.data);
  }

  async function getPriceLists() {
    let response = await wsGetAll('logi/price-list');
    if (response.success) setPriceLists(response.data);
  }

  async function getCountries() {
    let response = await wsGetAll('base/country');
    if (response.success) setCountries(response.data);
  }

  async function listBanks() {
    let response = await wsGetAll('base/bank');
    if (response.success) {
      setBanks(response.data);
    }
  }

  async function listPaymentTerms() {
    let response = await wsGetAll('base/payment-term');
    if (response.success) setPaymentTerms(response.data);
  }

  useEffect(() => {
    listTaxs();
    getPriceLists();
    getCountries();
    listBanks();
    listPaymentTerms();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="% Retraso"
          fullWidth
          type="number"
          name="IntrstRate"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange, min: 0 }}
          value={bPartner.IntrstRate || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Lista de Precios</InputLabel>
          <Select
            value={bPartner.ListNum || ''}
            inputProps={{
              name: 'ListNum',
              onChange: handleChange,
            }}
          >
            {priceLists.map((priceL, i) => {
              return (
                <MenuItem value={priceL.ListNum} key={i}>
                  {priceL.ListName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="% Descuento"
          fullWidth
          type="number"
          name="Discount"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange, min: 0 }}
          value={bPartner.Discount || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="Línea crédito"
          fullWidth
          type="number"
          name="CreditLine"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange, min: 0 }}
          value={bPartner.CreditLine || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Término de pago</InputLabel>
          <Select
            value={bPartner.GroupNum || ''}
            inputProps={{
              name: 'GroupNum',
              onChange: handleChange,
            }}
          >
            {paymentTerms.map((item, i) => {
              return (
                <MenuItem value={item.GroupNum} key={i}>
                  {item.PymntGroup}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="Línea comprometido"
          fullWidth
          type="number"
          name="DebtLine"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange, min: 0 }}
          value={bPartner.DebtLine || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Grupo desc.</InputLabel>
          <Select
            value={bPartner.DiscRel || ''}
            inputProps={{
              name: 'DiscRel',
              onChange: handleChange,
            }}
          >
            <MenuItem value="L">Desc. + bajo</MenuItem>
            <MenuItem value="H">Desc + alto</MenuItem>
            <MenuItem value="A">Promedio</MenuItem>
            <MenuItem value="S">Total</MenuItem>
            <MenuItem value="M">Mult. Desc.</MenuItem>
          </Select>
        </FormControl>
      </GridItem>

      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Precio efectivo</InputLabel>
          <Select
            value={bPartner.EffecPrice || ''}
            inputProps={{
              name: 'EffecPrice',
              onChange: handleChange,
            }}
          >
            <MenuItem value="D">Precio x Defecto</MenuItem>
            <MenuItem value="L">Precio + bajo</MenuItem>
            <MenuItem value="H">Precio + alto</MenuItem>
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>País</InputLabel>
          <Select
            value={bPartner.HousBnkCry || ''}
            inputProps={{
              name: 'HousBnkCry',
              onChange: handleChange,
            }}
          >
            {countries.map((country, i) => {
              return (
                <MenuItem value={country.Code} key={i}>
                  {country.Name}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Banco</InputLabel>
          <Select
            value={bPartner.HouseBank || ''}
            inputProps={{
              name: 'HouseBank',
              onChange: handleChange,
            }}
          >
            {banks.map((bank, i) => {
              return (
                <MenuItem value={bank.BankName} key={i}>
                  {bank.BankName}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="Cuenta"
          fullWidth
          name="HousBnkAct"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange }}
          value={bPartner.HousBnkAct || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Impuesto</InputLabel>
          <Select
            value={bPartner.base_tax_id || ''}
            inputProps={{
              name: 'base_tax_id',
              onChange: handleChange,
            }}
          >
            {taxs.map((tax, i) => {
              return (
                <MenuItem value={tax.id} key={i}>
                  {tax.Code}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo Inpuesto</InputLabel>
          <Select
            value={bPartner.VatStatus || ''}
            inputProps={{
              name: 'VatStatus',
              onChange: handleChange,
            }}
          >
            <MenuItem value="Y">Obligatorio</MenuItem>
            <MenuItem value="N">Extranjero</MenuItem>
          </Select>
        </FormControl>
      </GridItem>

      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>SN Agente Percepción</InputLabel>
          <Select
            value={bPartner.U_SYP_TPER || ''}
            inputProps={{
              name: 'U_SYP_TPER',
              onChange: handleChange,
            }}
          >
            <MenuItem value="Y">Si</MenuItem>
            <MenuItem value="N">No</MenuItem>
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>SN de Retención</InputLabel>
          <Select
            value={bPartner.U_SYP_AGENRE || ''}
            inputProps={{
              name: 'U_SYP_AGENRE',
              onChange: handleChange,
            }}
          >
            <MenuItem value="Y">Si</MenuItem>
            <MenuItem value="N">No</MenuItem>
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>SN Buen Contribuyente</InputLabel>
          <Select
            value={bPartner.U_SYP_SNBUEN || ''}
            inputProps={{
              name: 'U_SYP_SNBUEN',
              onChange: handleChange,
            }}
          >
            <MenuItem value="Y">Si</MenuItem>
            <MenuItem value="N">No</MenuItem>
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Exonerado Percepción</InputLabel>
          <Select
            value={bPartner.U_SYP_EXOPER || ''}
            inputProps={{
              name: 'U_SYP_EXOPER',
              onChange: handleChange,
            }}
          >
            <MenuItem value="Y">Si</MenuItem>
            <MenuItem value="N">No</MenuItem>
          </Select>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="Balance"
          fullWidth
          disabled
          type="number"
          name="Balance"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange }}
          value={bPartner.Balance || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="Comentarios"
          multiline
          fullWidth
          name="Free_Text"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange }}
          value={bPartner.Free_Text || ''}
        />
      </GridItem>
      <GridItem xs={12} sm={4} md={4} lg={2}>
        <TextField
          label="Cuenta deudores / Pago a proveedores"
          multiline
          fullWidth
          name="DebPayAcct"
          margin="normal"
          size="small"
          inputProps={{ onChange: handleChange }}
          // disabled={!(bPartner.QryGroup5 === 'Y' || bPartner.QryGroup7 === 'Y')}
          value={bPartner.DebPayAcct || ''}
        />
      </GridItem>
    </GridContainer>
  );
}
